import styled from 'styled-components';

import { theme } from 'coreOld/themes';

export const iconStyle = (isGrabbing = false) => ({
  fontSize: '1rem',
  color: theme.palette.text.placeholder,
  cursor: isGrabbing ? 'grabbing' : 'grab',
});

export const HandleWrapper = styled.div``;
